import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";

export default function PostBusiness() {


  const [formData, setFormData] = useState({
    business_title: "",
    price: "",
    total_cut_value: "",
    yearly_revenue: "",
    clients_count: "",
    suburb: "",
    state: "",
    postcode: "",
    business_description: "",
    vehicle_included: "0",
    vehicle_details: "",
    trailer_included: "0",
    trailer_details: "",
    equipment_included: "0",
    equipment_details: "",
    promoCode: "",
    enquiry_only: "0",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");
    setLoading(true);

    const token = localStorage.getItem("token");

    if (!token) {
      setErrorMessage("Authentication expired. Please log in again.");
      setLoading(false);
      return;
    }

    try {
      // 1️⃣ BUILD PAYLOAD FOR DRAFT BUSINESS LISTING
      const payload = {
        business_title: formData.business_title,
        business_description: formData.business_description,
        price: formData.price,
        total_cut_value: formData.total_cut_value,
        yearly_revenue: formData.yearly_revenue,
        clients_count: formData.clients_count,
        suburb: formData.suburb,
        state: formData.state,
        postcode: formData.postcode,
        vehicle_included: formData.vehicle_included,
        vehicle_details: formData.vehicle_details,
        trailer_included: formData.trailer_included,
        trailer_details: formData.trailer_details,
        equipment_included: formData.equipment_included,
        equipment_details: formData.equipment_details,
        enquiry_only: formData.enquiry_only,
        badge: "B",
        // status + sale_type handled by backend (status = 'draft', sale_type='business')
      };

      // 2️⃣ CREATE DRAFT LISTING
      const draftRes = await axios.post(
        `${API_BASE_URL}/api/lawn-mowing/business/create`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!draftRes.data.success || !draftRes.data.business_id) {
        console.error("Draft business create failed:", draftRes.data);
        setErrorMessage(
          draftRes.data.message || "Failed to create draft business listing."
        );
        setLoading(false);
        return;
      }

      const businessId = draftRes.data.business_id;

      // 3️⃣ START STRIPE CHECKOUT
      const stripeRes = await axios.post(
        `${API_BASE_URL}/api/lawn-mowing/business/payment`,
       {
  listing_id: businessId,
  listing_type: "business",
  promoCode: formData.promoCode,
},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
if (stripeRes.data.promoApplied) {
  window.location.href = `/promotion-activation-success?listingId=BUS-${businessId}`;
  return;
}

      if (!stripeRes.data || !stripeRes.data.url) {
        console.error("Stripe session creation failed:", stripeRes.data);
        setErrorMessage("Stripe session failed. Please try again.");
        setLoading(false);
        return;
      }

      // 4️⃣ REDIRECT TO STRIPE CHECKOUT
      window.location.href = stripeRes.data.url;
    } catch (err) {
      console.error("Business posting error:", err);
      setErrorMessage("Server error while posting listing.");
      setLoading(false);
    }
  };

  const container = {
    maxWidth: "700px",
    margin: "120px auto 20px",
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    zIndex: 1,
    position: "relative",
  };

  const header = {
    color: "#2e7d32",
    fontWeight: "bold",
    fontSize: "1.6rem",
    marginBottom: "20px",
  };

  const sectionHeader = {
    background: "#e8f5e9",
    padding: "10px",
    borderRadius: "6px",
    marginTop: "20px",
    fontWeight: "bold",
    color: "#1b5e20",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    marginTop: "8px",
    marginBottom: "12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  };

  const submitButton = {
    width: "100%",
    padding: "14px",
    background: "#2e7d32",
    color: "#fff",
    border: "none",
    fontSize: "1.2rem",
    fontWeight: "bold",
    borderRadius: "8px",
    marginTop: "25px",
    cursor: "pointer",
  };

  return (
    <div style={container}>
      <div style={header}>Create Gardening / Lawncare Business Listing</div>

      {errorMessage && (
        <p style={{ color: "red", marginBottom: "10px" }}>{errorMessage}</p>
      )}

      {successMessage && (
        <p style={{ color: "green", marginBottom: "10px" }}>{successMessage}</p>
      )}

      <form onSubmit={handleSubmit}>
        <div style={sectionHeader}>Business Information</div>

        <label>Business Name / Title</label>
        <input
          name="business_title"
          style={inputStyle}
          value={formData.business_title}
          onChange={handleChange}
          required
        />

        <label>Price ($)</label>
        <input
          type="number"
          name="price"
          style={inputStyle}
          value={formData.price}
          onChange={handleChange}
          required
        />

        <label>Total Cut Value ($)</label>
        <input
          type="number"
          name="total_cut_value"
          style={inputStyle}
          value={formData.total_cut_value}
          onChange={handleChange}
          required
        />

        <label>Yearly Revenue ($)</label>
        <input
          type="number"
          name="yearly_revenue"
          style={inputStyle}
          value={formData.yearly_revenue}
          onChange={handleChange}
          required
        />

        <label>Number of Clients</label>
        <input
          type="number"
          name="clients_count"
          style={inputStyle}
          value={formData.clients_count}
          onChange={handleChange}
        />

        <label>Suburb</label>
        <input
          name="suburb"
          style={inputStyle}
          value={formData.suburb}
          onChange={handleChange}
          required
        />

        <label>State</label>
        <select
          name="state"
          value={formData.state}
          onChange={handleChange}
          style={inputStyle}
          required
        >
          <option value="">Select State</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="WA">WA</option>
          <option value="TAS">TAS</option>
          <option value="NT">NT</option>
          <option value="ACT">ACT</option>
        </select>

        <label>Postcode</label>
        <input
          name="postcode"
          style={inputStyle}
          value={formData.postcode}
          onChange={handleChange}
        />

        <label>Description</label>
        <textarea
          name="business_description"
          rows="4"
          style={inputStyle}
          value={formData.business_description}
          onChange={handleChange}
          required
        />

        <div style={sectionHeader}>Included Items</div>

        <label>Vehicle Included?</label>
        <select
          name="vehicle_included"
          value={formData.vehicle_included}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {formData.vehicle_included === "1" && (
          <>
            <label>Vehicle Details</label>
            <textarea
              name="vehicle_details"
              rows="2"
              style={inputStyle}
              value={formData.vehicle_details}
              onChange={handleChange}
            />
          </>
        )}

        <label>Trailer Included?</label>
        <select
          name="trailer_included"
          value={formData.trailer_included}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {formData.trailer_included === "1" && (
          <>
            <label>Trailer Details</label>
            <textarea
              name="trailer_details"
              rows="2"
              style={inputStyle}
              value={formData.trailer_details}
              onChange={handleChange}
            />
          </>
        )}

        <label>Equipment Included?</label>
        <select
          name="equipment_included"
          value={formData.equipment_included}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {formData.equipment_included === "1" && (
          <>
            <label>Equipment Details</label>
            <textarea
              name="equipment_details"
              rows="2"
              style={inputStyle}
              value={formData.equipment_details}
              onChange={handleChange}
            />
          </>
        )}
<label>Promotion Code (Optional)</label>
<input
  type="text"
  name="promoCode"
  value={formData.promoCode}
  onChange={handleChange}
  style={inputStyle}
  placeholder="Enter promotion code"
/>
        

        <button type="submit" style={submitButton} disabled={loading}>
          {loading ? "Processing..." : "Post Business & Pay"}
        </button>
      </form>
    </div>
  );
}
